<template>
  <div class="row">
    <div class="col-md-12">
      <div class="shadow p-3 mb-3 bg-white rounded">
        <h5>
          <slot name="header"></slot>
        </h5>
        <slot name="btn"></slot>
      </div>
    </div>
    <div class="col-md-12">
      <div class="shadow p-3 mb-3 bg-white rounded filter">
        <h5><slot name="headerfilter"></slot></h5>
        <slot name="filter"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      types: [],
      sort: "CREATED_AT",
      btn: {
        experience: false,
        tour: false,
        event: false,
        story: false,
      },
    };
  },
  methods: {
    onAdd(type) {
      this.$emit("onAdd", type);
    },
    onClickChangeStatus(status) {
      this.$emit("onClickChangeStatus", status);
    },
    onSearch() {
      const data = {
        search: this.search,
        types: this.types,
        sort: this.sort,
      };
      this.$emit("search", data);
    },
    onReset() {
      this.search = "";
      this.types = [];
      this.btn.experience = false;
      this.btn.tour = false;
      this.btn.event = false;
      this.btn.story = false;
    },
    addTypes(type) {
      const index = this.types.indexOf(type);
      if (index > -1) {
        this.types.splice(index, 1);
      } else {
        this.types.push(type);
      }

      if (type == "experience") {
        this.btn.experience = !this.btn.experience;
      }

      if (type == "tour") {
        this.btn.tour = !this.btn.tour;
      }

      if (type == "event") {
        this.btn.event = !this.btn.event;
      }

      if (type == "story") {
        this.btn.story = !this.btn.story;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h5 {
  color: var(--primary-color);
}
.filter {
  .btn {
    color: #fff;
    border-radius: 19px;
    text-transform: none;

    &.btn-status {
      background-color: var(--primary-color);
    }
    &.btn-experiences {
      background-color: var(--experience-color);
    }
    &.btn-tours {
      background-color: var(--tour-color);
    }
    &.btn-events {
      background-color: var(--event-color);
    }
    &.btn-stories {
      background-color: var(--story-color);
    }

    &.btn-apply {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: var(--primary-color);
    }

    &.btn-reset {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #58595b;
    }

    &:hover {
      background-color: #58595b;
    }

    &.active {
      background-color: #58595b;
    }
  }
}
</style>